import { useEffect, useState } from "react"
import type { OverrideKind, ScheduleOverridePreview } from "../scheduleOverridesApi"

/** AmsScheduleOverrideKind.SiteClosure: nobody inside it can take a moved appointment. */
export const SITE_CLOSURE: OverrideKind = 2

/**
 * Out of office, a site closure and a temporary site reassignment (kind 0, which closes the host at
 * their other sites, AB#805) make somebody unavailable; an event-type override lists no bookings.
 */
export function affectsBookings(kind: OverrideKind | null): boolean {
  return kind === 0 || kind === 1 || kind === SITE_CLOSURE
}

/** What the preview panel shows: the latest answer for the settled form, a failure as an error, or nothing yet. */
export function previewFor(
  settled: boolean,
  query: { currentData?: ScheduleOverridePreview; isError: boolean },
): ScheduleOverridePreview | null {
  if (!settled) return null
  if (query.isError) return { errors: ["Could not check this override. Try again in a moment."], warnings: [], lines: [] }
  return query.currentData ?? null
}

/** `value`, once it has stayed the same for `delayMs`. Used by the availability week's override form (AB#806). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
